import countryList from 'react-select-country-list'

function getCountryOptions() {
  return countryList()
    .getData()
    .map((obj) => ({ ...obj, key: obj.label }))
}

export default getCountryOptions
